import React, { useEffect, useState } from "react";

function CatalogFilterCheckboxItem({ item, onFilterCbClick, isApplied = false }) {
  const data_val = JSON.stringify({
    choice_type: item?.choice_type,
    title: item?.title,
    items: [
      {
        id: item?.id,
        name: item?.name,
        url_slug: item?.url_slug,
      },
    ],
  });

  const [isCbChecked, setIsCbChecked] = useState(false);

  useEffect(() => {
    setIsCbChecked(isApplied);
  }, [isApplied])

  const handleCbChange = (data, isChecked) => {
    let item_data = JSON.parse(data) || {};
    setIsCbChecked(isChecked);
    onFilterCbClick(item_data, isChecked);
  };

  return (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        value=""
        data-val={data_val}
        checked={isCbChecked}
        onChange={(e) =>
          handleCbChange(e.target.getAttribute("data-val"), e.target.checked)
        }
        id={"cbitem-" + item?.url_slug}
      />
      <label className="form-check-label" htmlFor={"cbitem-" + item?.url_slug}>
        {item?.name}
      </label>
    </div>
  );
}

export default CatalogFilterCheckboxItem;
